export default () => {
  localStorage.removeItem("user");
  window.location.replace("/");
};
